<template>
  <div>
    <div class="max-w-xl mx-auto px-8 my-8 text-teal-900">
      <div
        class="bg-teal-100 border-t-4 border-teal-500 rounded-b text-teal-900 px-4 py-3 my-4 shadow-md"
        role="alert"
      >
        <div class="flex">
          <div class="py-1">
            <svg
              class="fill-current h-6 w-6 text-teal-500 mr-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path
                d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"
              />
            </svg>
          </div>
          <div>
            <p class="font-bold">Thanks!!</p>
            <p class="text-sm">Your photos are below.</p>
          </div>
        </div>
      </div>
      <div
        class="bg-gray-100 overflow-hidden leading-8 shadow rounded-lg divide-y divide-gray-200 my-5 p-8"
      >
        <div class="pb-5 mb-5 text-center">
          <div class="font-bold">Your Rafting Photos</div>
          <div>
            Had a great time whitewater rafting with {{ outfitter.name }}
          </div>
        </div>

        <p class="pt-5 text-center">
          <span v-if="zipDownloadUrl">
            Get your zip file click
            <a
              class="text-blue-500 cursor-pointer"
              target="_blank"
              :href="zipDownloadUrl"
              >HERE</a
            >
            <br />
            If your browser blocks this download please right click the link and
            select 'Save link as...'
          </span>
          <span v-else-if="zipBuilding">
            <svg class="animate-spin inline-block h-5 w-5 text-teal-500 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Building your zip file...
          </span>
          <span v-else-if="zipFailed">
            There was a problem building your zip file. Click
            <span class="text-blue-500 cursor-pointer" @click="initiateZip"
              >HERE</span
            >
            to try again.
          </span>
          <span v-else>
            It looks like your zip file has expired. Click
            <span class="text-blue-500 cursor-pointer" @click="initiateZip"
            >HERE</span
            >
            to generate a new zip file.
          </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Zip",

  data() {
    return {
      zipBuilding: false,
      zipFailed: false,
      zipDownloadUrl: null,
      zipPollTimer: null,
    };
  },
  methods: {
    async initiateZip() {
      this.zipBuilding = true;
      this.zipFailed = false;
      this.zipDownloadUrl = null;

      const resp = await this.$store.dispatch("order/zip", this.order.id);
      if (resp && resp.status === "completed" && resp.download_url) {
        this.zipBuilding = false;
        this.zipDownloadUrl = resp.download_url;
        return;
      }

      this.startPolling();
    },
    startPolling() {
      this.stopPolling();
      this.zipPollTimer = setInterval(() => this.pollZipStatus(), 3000);
    },
    stopPolling() {
      if (this.zipPollTimer) {
        clearInterval(this.zipPollTimer);
        this.zipPollTimer = null;
      }
    },
    async pollZipStatus() {
      const resp = await this.$store.dispatch("order/zipStatus", this.order.id);
      if (!resp || !resp.success) return;

      if (resp.status === "completed") {
        this.stopPolling();
        this.zipBuilding = false;
        this.zipDownloadUrl = resp.download_url;
      } else if (resp.status === "failed") {
        this.stopPolling();
        this.zipBuilding = false;
        this.zipFailed = true;
      }
    },
    async checkZipStatus() {
      const resp = await this.$store.dispatch("order/zipStatus", this.order.id);
      if (!resp || !resp.success) return;

      if (resp.status === "completed" && resp.download_url) {
        this.zipDownloadUrl = resp.download_url;
      } else if (resp.status === "pending" || resp.status === "processing") {
        this.zipBuilding = true;
        this.startPolling();
      } else if (resp.status === "failed") {
        this.zipFailed = true;
      }
    },
  },
  computed: {
    outfitter: function () {
      return this.$store.getters["search/getOutfitter"];
    },
    order: function () {
      return this.$store.getters["order/getOrder"];
    },
  },
  watch: {
    "order.id": function (newId) {
      if (newId) {
        this.checkZipStatus();
      }
    },
  },
  mounted() {
    this.$store.dispatch("order/load_order_hash", this.$route.params.orderHash);
    localStorage.removeItem("wwp-orderId");
  },
  beforeDestroy() {
    this.stopPolling();
  },
};
</script>
